module.exports = __webpack_public_path__ + "assets/img/首页小图-蘑菇小兵.c2088d9f.png";